<template>
  <BaseModal
    :id="`deleteReview_${reviewUid}`"
    :title="$label('books.reviews.deleteReviewModalTitle')"
    :static-modal="staticModal"
  >
    <template #body>
      <p>{{ $label('books.reviews.deleteReviewConfirmText') }}</p>
    </template>

    <template #footer>
      <BaseButton
        :class="['confirm-btn', { loading: isLoading }]"
        variant="primary"
        @click="onConfirmDelete"
      >
        {{ $label('books.reviews.deleteReviewConfirmBtn') }}
      </BaseButton>
      <BaseButton class="cancel-btn" variant="secondary" @click="hideModal">
        {{ $label('common.cancel') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
export default {
  props: {
    deleteReview: {
      type: Function,
      required: true,
    },
    updateReviews: {
      type: Function,
      required: true,
    },
    reviewUid: {
      type: String,
      default: '',
    },
    hideModal: {
      type: Function,
      required: true,
    },
    staticModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async onConfirmDelete() {
      try {
        this.isLoading = true

        await this.deleteReview(this.reviewUid)
        await this.updateReviews()
      } catch (error) {
        this.$toast.error(this.$label('messages.errorOccuredMessage'))
        this.$sentryCaptureException(error)
      } finally {
        this.isLoading = false
        this.hideModal()
      }
    },
  },
}
</script>
